import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_ResponsiveNavbar = _resolveComponent("ResponsiveNavbar")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_WhyChoiceForYou = _resolveComponent("WhyChoiceForYou")!
  const _component_FeaturesContent = _resolveComponent("FeaturesContent")!
  const _component_Anniversary = _resolveComponent("Anniversary")!
  const _component_HowItWorks = _resolveComponent("HowItWorks")!
  const _component_WhatOurCustomerSays = _resolveComponent("WhatOurCustomerSays")!
  const _component_WhatOurCustomerSaysTwo = _resolveComponent("WhatOurCustomerSaysTwo")!
  const _component_FrequentlyAskedQuestions = _resolveComponent("FrequentlyAskedQuestions")!
  const _component_DownloadTheApp = _resolveComponent("DownloadTheApp")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, { class: "home_one" }),
    _createVNode(_component_ResponsiveNavbar, { class: "home_one" }),
    _createVNode(_component_MainBanner),
    _createVNode(_component_WhyChoiceForYou),
    _createVNode(_component_FeaturesContent),
    _createVNode(_component_Anniversary),
    _createVNode(_component_HowItWorks),
    _createVNode(_component_WhatOurCustomerSays),
    _createVNode(_component_WhatOurCustomerSaysTwo),
    _createVNode(_component_FrequentlyAskedQuestions),
    _createVNode(_component_DownloadTheApp),
    _createVNode(_component_MainFooter)
  ], 64))
}